import React from 'react';
import SEO from '../components/SEO';
import './StaticPages.css';

function ContactPage() {
  return (
    <main className="static-page">
      <SEO 
        title="Contact E Media Forum - Get in Touch"
        description="Contact E Media Forum for press inquiries, story tips, partnerships, and general information."
      />
      
      <div className="page-header">
        <h1>Contact Us</h1>
      </div>
      
      <div className="page-content">
        <section className="content-section">
          <h2>Get in Touch</h2>
          <p>
            We welcome your feedback, story tips, and inquiries. Our editorial team is committed to 
            providing accurate and timely entertainment industry coverage.
          </p>
        </section>
        
        <div className="contact-grid">
          <div className="contact-item">
            <h3>Editorial Inquiries</h3>
            <p>For story tips, press releases, and editorial matters:</p>
            <p><strong>Email:</strong> info@emediaforum.com</p>
          </div>
          
          <div className="contact-item">
            <h3>General Information</h3>
            <p>For general questions and information:</p>
            <p><strong>Email:</strong> info@emediaforum.com</p>
          </div>
          
          <div className="contact-item">
            <h3>Business Partnerships</h3>
            <p>For advertising and partnership opportunities:</p>
            <p><strong>Email:</strong> info@emediaforum.com</p>
          </div>
          
          <div className="contact-item">
            <h3>Technical Support</h3>
            <p>For website issues and technical support:</p>
            <p><strong>Email:</strong> info@emediaforum.com</p>
          </div>
        </div>
        
        <section className="content-section">
          <h2>Follow Our Coverage</h2>
          <p>
            Stay updated with the latest entertainment industry news by following us on social media 
            and subscribing to our newsletter for daily updates and exclusive content.
          </p>
        </section>
      </div>
    </main>
  );
}

export default ContactPage;